var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { staticStyle: { "max-height": "100vh", height: "100vh" } },
    [
      _c("HubMenu"),
      _c("Appbar"),
      _c("HubList", {
        attrs: {
          "sidebar-items": [
            {
              title: "",
              icon: "info",
              name: "info",
            },
          ],
          title: _vm.$t("forms.title"),
          items: _vm.forms || [],
          sidebar: true,
          "sidebar-width": 5,
          value: _vm.selectedForm,
        },
        on: { input: _vm.onSidebarChanged },
        scopedSlots: _vm._u(
          [
            {
              key: "item-icon",
              fn: function () {
                return [
                  _c(
                    "v-icon",
                    { attrs: { small: "", color: "primary lighten-3" } },
                    [_vm._v("list_alt")]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: `sidebar.info`,
              fn: function ({ item }) {
                return [
                  item
                    ? _c("FormsGeneral", { attrs: { form: item } })
                    : _vm._e(),
                ]
              },
            },
            {
              key: "toolbar",
              fn: function () {
                return [
                  _vm.isOwner || _vm.isAdmin
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "primary lighten-1", text: "" },
                          on: {
                            click: function ($event) {
                              _vm.newFormularAlert = false
                              _vm.showNewFormDialog = true
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("forms.newForm.btn")) + " "
                          ),
                          _c(
                            "v-icon",
                            { staticClass: "me-1", attrs: { right: "" } },
                            [_vm._v("mdi-plus-circle")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "HubDialog",
        {
          attrs: {
            title: _vm.$t("forms.newForm.title"),
            "primary-label": _vm.$t("common.create"),
            "secondary-label": _vm.$t("common.cancel"),
            "primary-icon": "add",
            disabled: _vm.newFormular === "" || !_vm.isQuotaOk,
            modal: "",
          },
          on: { onPrimary: _vm.newForm },
          model: {
            value: _vm.showNewFormDialog,
            callback: function ($$v) {
              _vm.showNewFormDialog = $$v
            },
            expression: "showNewFormDialog",
          },
        },
        [
          !_vm.isQuotaOk
            ? _c(
                "div",
                [
                  _c("InfoBox", {
                    attrs: {
                      text: _vm.$tc("forms.newForm.noQuotaLeft", _vm.quota, {
                        count: _vm.quota,
                      }),
                      icon: "mdi-comment-alert-outline",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("v-text-field", {
            attrs: { autofocus: "", label: _vm.$t("common.name") },
            model: {
              value: _vm.newFormular,
              callback: function ($$v) {
                _vm.newFormular = $$v
              },
              expression: "newFormular",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }